import { render, staticRenderFns } from "./indexBar.vue?vue&type=template&id=1915a72f&"
import script from "./indexBar.vue?vue&type=script&lang=js&"
export * from "./indexBar.vue?vue&type=script&lang=js&"
import style0 from "./indexBar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports